var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgGiftChatLite = function SvgGiftChatLite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 8.954 31.046 0 20 0S0 8.954 0 20s8.954 20 20 20 20-8.954 20-20z",
    fill: "#E7E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 20v6.76c0 1.158 0 1.737-.233 2.176a2 2 0 01-.831.831c-.44.233-1.018.233-2.176.233h-9.52c-1.158 0-1.737 0-2.176-.233a2 2 0 01-.832-.831C12 28.496 12 27.918 12 26.76V20M27.5 15h-15c-.465 0-.697 0-.89.038a2 2 0 00-1.572 1.572c-.038.193-.038.425-.038.89s0 .697.038.89a2 2 0 001.572 1.572c.193.038.425.038.89.038h15c.465 0 .697 0 .89-.038a2 2 0 001.572-1.572c.038-.193.038-.425.038-.89s0-.697-.038-.89a2 2 0 00-1.572-1.572C28.197 15 27.965 15 27.5 15zM20 30V15M20 15h-4.5a2.5 2.5 0 010-5c3.5 0 4.5 5 4.5 5zM20 15h4.5a2.5 2.5 0 000-5C21 10 20 15 20 15z",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgGiftChatLite;